export default __webpack_public_path__ + "static/media/schneider-logo.ff91edcc.png";